export default __webpack_public_path__ + "static/media/ic_receipt.4c44ac68.svg";